import { Solution } from '@energiebespaarders/constants';
export interface EstimateProduct {
  title: string;
  isIncluded?: boolean;
  unit?: string;
}

const hybridHeatPumpEstimateProducts: EstimateProduct[] = [
  { title: 'Binnen- en buitenunit' },
  { title: 'Slimme thermostaat', isIncluded: true },
  { title: 'Kabeltracé', isIncluded: true },
  { title: 'Installatiemateriaal', isIncluded: true },
  { title: 'Installatiekosten', isIncluded: true },
];
const electricHeatPumpEstimateProducts: EstimateProduct[] = [
  { title: 'Binnen- en buitenunit' },
  { title: 'Slimme thermostaat', isIncluded: true },
  { title: 'Kabeltracé', isIncluded: true },
  { title: 'Installatiemateriaal', isIncluded: true },
  { title: 'Installatiekosten', isIncluded: true },
];
const airToAirHeatPumpEstimateProducts: EstimateProduct[] = [
  { title: 'Binnenunits' },
  { title: 'Buitenunit', isIncluded: true },
  { title: 'Installatiekosten', isIncluded: true },
];
const centralHeatingBoilerEstimateProducts: EstimateProduct[] = [
  { title: 'Cv-ketel met A-label pomp', isIncluded: true },
  { title: 'Installatiekosten', isIncluded: true },
];

const pvSystemEstimateProducts: EstimateProduct[] = [
  { title: 'Zonnepanelen' },
  { title: 'Omvormer', isIncluded: true },
  { title: 'Optimizers', isIncluded: true },
  { title: 'Installatiekosten', isIncluded: true },
];
const chargingBoxEstimateProducts: EstimateProduct[] = [
  { title: 'Laadpaal' },
  { title: 'Kabeltracé', isIncluded: true },
  { title: 'Installatiekosten', isIncluded: true },
];
const wallInsulationEstimateProducts: EstimateProduct[] = [
  { title: 'Isolatiemateriaal', unit: 'm2' },
  { title: 'Installatiekosten', isIncluded: true },
];
const floorInsulationEstimateProducts: EstimateProduct[] = [
  { title: 'Isolatiemateriaal', unit: 'm2' },
  { title: 'Installatiekosten', isIncluded: true },
];
const crawlspaceInsulationEstimateProducts: EstimateProduct[] = [
  { title: 'Isolatiemateriaal', unit: 'm2' },
  { title: 'Installatiekosten', isIncluded: true },
];
const innerRoofInsulationEstimateProducts: EstimateProduct[] = [
  { title: 'Isolatiemateriaal', unit: 'm2' },
  { title: 'Installatiekosten', isIncluded: true },
];
const windowGlazingEstimateProducts: EstimateProduct[] = [
  { title: 'Isolatiemateriaal', unit: 'm2' },
  { title: 'Installatiekosten', isIncluded: true },
];
const homeBatteryEstimateProducts: EstimateProduct[] = [
  { title: 'Thuisbatterij' },
  { title: 'Installatiekosten', isIncluded: true },
];

export const estimateProductsBySolution: Record<Solution, EstimateProduct[]> = {
  [Solution.PvSystem]: pvSystemEstimateProducts,
  [Solution.WallInsulation]: wallInsulationEstimateProducts,
  [Solution.FloorInsulation]: floorInsulationEstimateProducts,
  [Solution.CrawlspaceInsulation]: crawlspaceInsulationEstimateProducts,
  [Solution.InnerRoofInsulation]: innerRoofInsulationEstimateProducts,
  [Solution.AtticFloorInsulation]: [],
  [Solution.CentralHeatingBoiler]: centralHeatingBoilerEstimateProducts,
  [Solution.HybridHeatPump]: hybridHeatPumpEstimateProducts,
  [Solution.ElectricHeatPump]: electricHeatPumpEstimateProducts,
  [Solution.AirToAirHeatPump]: airToAirHeatPumpEstimateProducts,
  [Solution.WindowGlazing]: windowGlazingEstimateProducts,
  [Solution.ChargingBox]: chargingBoxEstimateProducts,
  [Solution.WindowFrames]: [],
  [Solution.Sedum]: [],
  [Solution.Miscellaneous]: [],
  [Solution.UnderfloorHeating]: [],
  [Solution.HomeBattery]: homeBatteryEstimateProducts,
};

const baseImgixParams = '?w=600&auto=format,compress';

// TODO: Add missing photos
export const estimateInstallationPhotos: Record<Solution, string> = {
  [Solution.PvSystem]: `https://www.datocms-assets.com/50550/1688027255-debwarmtepomp_whp_8155.jpg${baseImgixParams}`,
  [Solution.WallInsulation]: `https://www.datocms-assets.com/50550/1684227028-spouwmuurisolatie_img_3603_wardie.jpg${baseImgixParams}`,
  [Solution.FloorInsulation]: `https://www.datocms-assets.com/50550/1705501719-vloerisolatie.webp${baseImgixParams}`,
  [Solution.CrawlspaceInsulation]: `https://www.datocms-assets.com/50550/1705501719-vloerisolatie.webp${baseImgixParams}`,
  [Solution.InnerRoofInsulation]: `https://www.datocms-assets.com/50550/1723630380-dakisolatie.jpg${baseImgixParams}`,
  [Solution.AtticFloorInsulation]: `https://www.datocms-assets.com/50550/1684227176-energiebespaarders_img_0571_wardie.jpg${baseImgixParams}`,
  [Solution.CentralHeatingBoiler]: `https://www.datocms-assets.com/50550/1684226556-energiebespaarders_img_0564_wardie.jpg${baseImgixParams}`,
  [Solution.HybridHeatPump]: `https://www.datocms-assets.com/50550/1684227323-debwarmtepomp_whp_8115.jpg${baseImgixParams}`,
  [Solution.ElectricHeatPump]: `https://www.datocms-assets.com/50550/1684227051-debwarmtepomp_whp_8194.jpg${baseImgixParams}`,
  [Solution.AirToAirHeatPump]: `https://www.datocms-assets.com/50550/1718207083-airco-installatie.jpeg${baseImgixParams}`,
  [Solution.WindowGlazing]: `https://www.datocms-assets.com/50550/1684227209-energiebespaarders_img_0462_wardie.jpg${baseImgixParams}`,
  [Solution.ChargingBox]: `https://www.datocms-assets.com/50550/1728544508-laadpaal-installateur.jpg${baseImgixParams}`,
  [Solution.WindowFrames]: `https://www.datocms-assets.com/50550/1731503771-kozijn_plaatsen.jpg${baseImgixParams}`,
  [Solution.Sedum]: '',
  [Solution.Miscellaneous]: '',
  [Solution.UnderfloorHeating]: '',
  [Solution.HomeBattery]: `https://www.datocms-assets.com/50550/1728565398-thuisbatterij-liggend-1024x683.jpg${baseImgixParams}`,
};

const removeBgParam = '&bg-remove=true';
// TODO: Add missing photos
export const estimateProductPhotos: Record<Solution, string> = {
  [Solution.PvSystem]: `https://www.datocms-assets.com/50550/1722867173-denim-n-type-topcon-440-wp-all-black.jpg${baseImgixParams}${removeBgParam}`,
  [Solution.WallInsulation]: `https://www.datocms-assets.com/50550/1722869611-frame-1000002570.jpg${baseImgixParams}${removeBgParam}`,
  [Solution.FloorInsulation]: `https://www.datocms-assets.com/50550/1722936368-052d233d-2374-485b-8f49-cde45e8964a1_size-ss.jpg${baseImgixParams}${removeBgParam}`,
  [Solution.CrawlspaceInsulation]: `https://www.datocms-assets.com/50550/1722936368-052d233d-2374-485b-8f49-cde45e8964a1_size-ss.jpg${baseImgixParams}${removeBgParam}`,
  [Solution.InnerRoofInsulation]: `https://www.datocms-assets.com/50550/1723630270-cbba31d4-6cf9-4b31-be35-93d14fdfeb9f_size-xl-edited.png${baseImgixParams}${removeBgParam}`,
  [Solution.AtticFloorInsulation]: `https://www.datocms-assets.com/50550/1723630270-cbba31d4-6cf9-4b31-be35-93d14fdfeb9f_size-xl-edited.png${baseImgixParams}${removeBgParam}`,
  [Solution.CentralHeatingBoiler]: `https://www.datocms-assets.com/50550/1695127546-cv-ketel.png${baseImgixParams}${removeBgParam}`,
  [Solution.HybridHeatPump]: `https://www.datocms-assets.com/50550/1737557991-remeha-quatt.png${baseImgixParams}${removeBgParam}`,
  [Solution.ElectricHeatPump]: `https://www.datocms-assets.com/50550/1722871009-zonnepanelen-2.jpg${baseImgixParams}${removeBgParam}`,
  [Solution.AirToAirHeatPump]: `https://www.datocms-assets.com/50550/1721224610-01ae143e-3032-44f5-8e78-69db3654876b_size-xl-1-3.jpg${baseImgixParams}${removeBgParam}`,
  [Solution.WindowGlazing]: `https://www.datocms-assets.com/50550/1722936827-753577f4-8934-4e0e-85f5-147534d181e5_size-xl.jpg${baseImgixParams}${removeBgParam}`,
  [Solution.ChargingBox]: `https://www.datocms-assets.com/50550/1728476798-583aa2d1-e943-412b-9229-72d9c61f54fd.png${baseImgixParams}${removeBgParam}`,
  [Solution.WindowFrames]: `https://www.datocms-assets.com/50550/1731502978-kunststof-vast-glas-kozijn-met-2-vakken-voor-schuin-300x300.avif${baseImgixParams}${removeBgParam}`,
  [Solution.Sedum]: '',
  [Solution.Miscellaneous]: '',
  [Solution.UnderfloorHeating]: '',
  [Solution.HomeBattery]: `https://www.datocms-assets.com/50550/1728565849-enphase-10t-batterij.png${baseImgixParams}${removeBgParam}`,
};
